import React from 'react';
import './App.css';
import ChatBot from './Chatbot';

function App() {
  return (
    <div className="App">
      <ChatBot />
    </div>
  );
}

export default App;